/**
 * Custom logger that respects debug mode
 *
 * Usage: logger.log("message"), logger.error("error")
 * Outputs only when ?debug=1 is in URL
 */

const isDebugEnabled = (): boolean => {
  if (typeof window === "undefined") return false;
  return sessionStorage.getItem("debug") === "1";
};

export const logger = {
  log: (...args: unknown[]): void => {
    if (isDebugEnabled()) console.log(...args);
  },
  error: (...args: unknown[]): void => {
    if (isDebugEnabled()) console.error(...args);
  },
  warn: (...args: unknown[]): void => {
    if (isDebugEnabled()) console.warn(...args);
  },
  info: (...args: unknown[]): void => {
    if (isDebugEnabled()) console.info(...args);
  },
  debug: (...args: unknown[]): void => {
    if (isDebugEnabled()) console.debug(...args);
  },
  trace: (...args: unknown[]): void => {
    if (isDebugEnabled()) console.trace(...args);
  },
};
